import { useEffect, useState } from 'react';
import { api, ApiError } from '../api';
import { snapshotForMerge } from '../state/visited';

export function VerifySignIn(props: { token: string }) {
  const [err, setErr] = useState('');

  useEffect(() => {
    api
      .get(`/auth/verify/${props.token}`)
      .then(async () => {
        const ids = snapshotForMerge();
        if (ids.length) await api.postJson('/visits/merge', { event_ids: ids }).catch(() => {});
        window.location.href = '/account';
      })
      .catch((e) => setErr(e instanceof ApiError ? e.message : 'Something went wrong'));
  }, [props.token]);

  if (err) {
    return (
      <div className="card" style={{ maxWidth: 420, margin: '80px auto' }}>
        <p>{err}</p>
        <a className="btn primary" href="/">
          Back to the map
        </a>
      </div>
    );
  }
  return <p style={{ textAlign: 'center', marginTop: 80 }}>Signing you in…</p>;
}
